import { render, staticRenderFns } from "./backPriceManage.vue?vue&type=template&id=03105213&scoped=true"
import script from "./backPriceManage.vue?vue&type=script&lang=js"
export * from "./backPriceManage.vue?vue&type=script&lang=js"
import style0 from "./backPriceManage.vue?vue&type=style&index=0&id=03105213&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03105213",
  null
  
)

export default component.exports